var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_70_2",
    "data-name": "Component 70 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.198,
    height: 64.198,
    viewBox: "0 0 64.198 64.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #066fef;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18448",
    "data-name": "Rectangle 18448",
    className: "cls-1",
    width: 23.315,
    height: 17.414
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    className: "cls-2",
    cx: 32.099,
    cy: 32.099,
    r: 32.099
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18751",
    "data-name": "Group 18751",
    transform: "translate(20.441 23.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18751-2",
    "data-name": "Group 18751",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8104",
    "data-name": "Path 8104",
    className: "cls-1",
    d: "M11.637,17.414q-4.932,0-9.864,0A1.545,1.545,0,0,1,.005,15.676Q0,10,0,4.33A1.524,1.524,0,0,1,1.728,2.615c1.558-.01,3.118-.029,4.675.012a.667.667,0,0,0,.781-.6c.114-.46.261-.912.383-1.371A.789.789,0,0,1,8.429,0q3.25.015,6.5,0a.815.815,0,0,1,.882.639,9.841,9.841,0,0,1,.376,1.311c.086.558.37.685.9.674,1.5-.033,3-.016,4.5-.01,1.206,0,1.727.531,1.728,1.736q0,5.673,0,11.347c0,1.177-.554,1.717-1.756,1.718H11.637m.334-13.046A5.059,5.059,0,1,0,17,9.519a5.025,5.025,0,0,0-5.034-5.151",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCamera);
export default __webpack_public_path__ + "static/media/button_camera.0d1b54f523419c0441b24e05c18b443e.svg";
export { ForwardRef as ReactComponent };